// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__36Hi7","col":"styles_col__3ZO7p"};